<app-programtitle title="Simple calculator"></app-programtitle>
<p> Write a simple calculator that can do addition, subtraction, multiplication and dvision only.</p>

<app-editor code="{{program}}"> </app-editor>